export default __webpack_public_path__ + "static/tujo-logo-black-57c29dba23e46675c5f50a97225a7faf.png";